import request from '@/utils/request'
import config from '@/config/config'

// 获取用户列表
export function getUserList (data) {
  return request({
    url: config.baseURL + '/api/users/list',
    method: 'post',
    data
  })
}

// 新增用户
export function addUser (data) {
  return request({
    url: config.baseURL + '/api/users/add',
    method: 'post',
    data
  })
}

// 修改用户
export function updateUser (data) {
  return request({
    url: config.baseURL + '/api/users/update',
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser (data) {
  return request({
    url: config.baseURL + '/api/users/delete',
    method: 'post',
    data
  })
}

// 获取用户详情
export function getUserDetail (data) {
  return request({
    url: config.baseURL + '/api/users/detail',
    method: 'post',
    data
  })
}

// 修改用户状态
export function updateUserStatus (data) {
  return request({
    url: config.baseURL + '/api/users/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user/index.js